export const gitCommit = 'e80d510a'
